<template>
    <div v-if="loaded">
        <rkm-area no-margin-top title="Filtros" type="fieldset">
            <rkm-form ref="Form" show-legend>
                <rkm-row>
                    <rkm-col cols="6">
                    <rkm-form-date-picker
                        :range-inline="false"
                        end-label="Até"
                        range
                        start-label="Período de"
                        v-model="model.periodo"
                        :start-validations="validations.periodo.start"
                        :end-validations="validations.periodo.end"
                    />
                    </rkm-col>
                    <rkm-col cols="6">
                        <rkm-form-select
                          :options="form.unidades"
                          default-option-text="Todas"
                          label="Unidade"
                          show-default-option
                          text-field="nomeFantasia"
                          v-model="model.unidadeId"
                          value-field="id"
                          @change="loadFields('unidade')"
                        />
                    </rkm-col>
                </rkm-row>
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                          :options="infraestruturas"
                          default-option-text="Todas"
                          label="Local de atendimento"
                          show-default-option
                          text-field="nome"
                          v-model="model.infraestruturaId"
                          value-field="id"
                          @change="loadFields('infraestrutura')"
                        />
                    </rkm-col>

                    <rkm-col class="flex-grow-1">
                        <rkm-form-select
                          :options="form.medicos"
                          default-option-text="Todas"
                          label="Médico solicitante"
                          show-default-option
                          text-field="medicoNome"
                          v-model="model.medicoId"
                          value-field="medicoId"
                          @change="resetSearch()"
                        />
                    </rkm-col>
                    <rkm-col cols="auto">
                        <rkm-button
                          :label="false"
                          @click="$refs.Form.validate(search)"
                          color="primary"
                        >
                            Buscar
                        </rkm-button>
                        <rkm-button
                          :label="false"
                          @click="reset"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>
        <rkm-area no-margin-top title="Resultado" v-if="isSearch">
            <template v-slot:trailing>
                <rkm-button
                  :disabled="itens.length === 0"
                  @click="print"
                  color="info"
                  small
                  title="Imprimir">
                    <rkm-icon icon="print" />
                </rkm-button>
                <rkm-button
                  :disabled="itens.length === 0"
                  @click="exportTo"
                  color="info"
                  small
                  title="Exportar">
                    <rkm-icon icon="file-export" />
                </rkm-button>
            </template>
            <rkm-table
              :fields="fields"
              :items="itens"
              no-footer-sorting
              sort-by=""
            >

                <template #afterTable>
                    <div class="table-th text-right">
                        Total: {{ totalizadores.total }}
                    </div>
                </template>
            </rkm-table>
        </rkm-area>
    </div>
</template>

<script>
import formatsFilter from '@/filters/formats'
import moment from 'moment'
import { mapActions } from 'vuex'
import { repository, error, data, object, stringCase, file } from '@/mixins'

export default {
    computed: {
        optionalColumns() {

            return this.columns.filter(c => !(c.fixed || false))
        },
        fields() {

            return this.columns.filter(c => (c.fixed || false) || this.selectedCols.includes(c.key))
        },
        validations() {

            return {
                periodo: {
                    start: { required: true },
                    end: { required: true },
                }
            }
        },
        isPeriodoSelecionado() {

            return this.model !== null
                && (this.model.periodo.start instanceof Date)
                && (this.model.periodo.end instanceof Date)
        },
        infraestruturas() {

            if (!this.model.unidadeId) {
                return []
            }

            const unidade = this.form.unidades.find(u => u.id === this.model.unidadeId)
            return unidade.infraestruturas
        },
    },
    created() {

        this.repositories = {
            relatorioPacienteAtendido: this.getConectaSusRepository('exameLaboratorial.relatorioPacienteAtendido'),
            impressao: this.getConectaSusRepository('impressao.exameLaboratorial'),
            exportacao: this.getConectaSusRepository('exportacao.exameLaboratorial'),
        }

        this.load()
    },
    data() {

        return {
            loaded: false,
            additionals: null,
            form: null,
            defaultModel: null,
            defaultForm: null,
            model: {
                unidadeId: null,
                medicoId: null,
                infraestruturaId: null,
                periodo: {
                    start: null,
                    end: null,
                },
            },
            selectedAll: false,
            indeterminate: true,
            selectedCols: [
                'dataPedido',
                'dataColeta',
                'id',
                'paciente',
                'medico',
                'unidade',
            ],
            columns: [
                {
                    key: 'dataPedido',
                    label: 'Data do agendamento',
                    sortable: true,
                    fixed: true,
                },
                {
                    key: 'dataColeta',
                    label: 'Data da coleta',
                    sortable: true,
                    fixed: true,
                },
                {
                    key: 'id',
                    label: 'Agendamento',
                    sortable: true,
                    fixed: true,
                },
                {
                    key: 'paciente',
                    label: 'Paciente',
                    sortable: true,
                    fixed: true,
                },
                {
                    key: 'medico',
                    label: 'Médico solicitante',
                    sortable: true,
                    fixed: true,
                },
                {
                    key: 'unidade',
                    label: 'Unidade',
                    sortable: true,
                    fixed: true,
                },
                {
                    key: 'local',
                    label: 'Local de atendimento',
                    sortable: true,
                    fixed: true,
                }
            ],
            itens: [],
            totalizadores: null,
            medico: [],
            unidade: [],
            isSearch: null
        }
    },
    methods: {
        ...formatsFilter,
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.relatorioPacienteAtendido.list()
                .then(({ data }) => {

                    this.additionals = data.additionals
                    this.form = data.form
                    this.model = data.model
                    this.defaultModel = this.clone(data.model)
                    this.defaultForm = this.clone(data.form)

                    this.model.periodo.start = moment(data.form.dataAtual, 'DD/MM/YYYY').toDate()
                    this.model.periodo.end = moment(data.form.dataAtual, 'DD/MM/YYYY').toDate()

                    this.addWatchers()

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        loadFrom(field) {

            this.clearFrom(field)

            this.setLoading()

            this.repositories.relatorioSaida.list({ ...this.prepareData(), load_from: this.camelToSnake(field) })
                .then(({ data }) => {

                    if ('form' in data) {

                        Object.keys(data.form).forEach(key => this.$set(this.form, key, data.form[key]))
                    }

                    Object.keys(data.model).forEach(key => this.$set(this.model, key, data.model[key]))
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        clearFrom(field) {

            if (field == 'periodo') {

                return
            }

            const fields = [
                'unidade',
                'medico',
            ]

            fields.slice(fields.indexOf(field) + 1, fields.length)
                .forEach(key => this.$set(this.model, key, null))
        },
        addWatchers() {

            this.$watch('model.unidadeId', function () {

                this.model.medicoId = null
            })

        },
        search() {

            this.setLoading()

            this.repositories.relatorioPacienteAtendido.index(this.getSearchParams())
                .then(({ data }) => {

                    this.itens = data.consulta
                    this.totalizadores = data.totalizadores
                    this.isSearch = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getSearchParams() {

            const params = this.clone(this.model)

            this.formateDates(params.periodo, ['start', 'end'], 'YYYY-MM-DD')

            return this.camelObjectKeysToSnakeRecursive(params)
        },
        reset() {

            this.model = this.clone(this.defaultModel)
            this.form = this.clone(this.defaultForm)
            this.isSearch = false
            this.setDefaultValues()

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        setDefaultValues() {

            this.model.periodo.start = moment(this.form.dataAtual, 'DD/MM/YYYY').toDate()
            this.model.periodo.end = moment(this.form.dataAtual, 'DD/MM/YYYY').toDate()
        },
        print() {

            this.setLoading()

            this.repositories.impressao.relatorioPacienteAtendido(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        exportTo() {

            this.setLoading()

            this.repositories.exportacao.relatorioPacienteAtendido(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        prepareDataWithColumns() {

            const data = this.prepareData()

            data.selectedCols = this.fields.map(f => ({
                key: this.camelToSnake(f.key),
                label: f.label,
                class: f.class
            }))

            return data
        },
        prepareData() {

            const data = this.clone(this.model)

            this.formateDates(data.periodo, ['start', 'end'], 'DD/MM/YYYY')

            return this.camelObjectKeysToSnakeRecursive(data)
        },
        setListagem() {

            this.itemsNotSave = null
            this.items = []
        },
        selectAll(selected) {

            this.selectedCols = selected ? this.columns.map(c => c.key) : []
        },
        loadFields(field) {

            this.setLoading()

            this.isSearch = false

            if (field == 'data') {
                this.model.unidadeId = null
                this.model.exameId = null
            } else {
                this.model.exameId = null
            }

            this.repositories.relatorioPacienteAtendido.list(this.prepareData())
                .then(({ data }) => {

                    if (field == 'data') {

                        this.form.unidades = data.form.unidades
                        this.form.medicos = data.form.medicos
                    } else {

                        this.form.medicos = data.form.medicos
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        resetSearch() {

            this.isSearch = false
        }
    },
    mixins: [repository, error, data, object, stringCase, file],
    watch: {
        model: {
            deep: true,
            handler() {

                this.itens = []
                this.totalizadores = null
            }
        },
        selectedCols(newValue) {

            this.selectedAll = newValue.length > 0 && newValue.length == this.columns.length
            this.indeterminate = newValue.length > 0 && newValue.length != this.columns.length
        },
        'model.periodo.start'() {

            if (this.model.periodo.start && this.model.periodo.end) {

                this.loadFields('data')
            }
        },
        'model.periodo.end'() {

            if (this.model.periodo.start && this.model.periodo.end) {

                this.loadFields('data')
            }
        }
    }
}
</script>

<style scoped>
.table-th {
    background: #f1f1f1;
    padding: 0 10px;
    height: 35px;
    line-height: 35px;
    font-weight: 600;
    border-top: 1px solid #dee2e6;
    border-left: 1px solid #dee2e6;
    border-right: 1px solid #dee2e6;
}
.table-td {
    background: #f1f1f1;
    padding: 0 10px;
    height: 35px;
    border-top: 1px solid #ccc;
    font-weight: 600;
}
.table-border-top {
    border-top: 0;
    height: 30px;
    padding: 0;
}
</style>